import $ from 'jquery';
import 'select2';

$(window).on('load resize', function () {
	$('.cf-im-interested-in select').select2();
});
